import {
    BaseLayer
} from "esdm-map";
import { IBaseLayer } from "esdm-map/dist/baselayers/interfaces/IBaseLayer";
import TileLayer from 'ol/layer/Tile';
import WMTS from 'ol/source/WMTS';
import WMTSTileGrid from 'ol/tilegrid/WMTS';

export class Cheshire_BaseLayers{
               
    public GetCheshireOS(): IBaseLayer {
        let lyr = new TileLayer({
            visible: true,
            source: new WMTS({                
                //url: 'https://maps-cache.cheshiresharedservices.gov.uk/maps/?wmts/OS_AllBasemaps_COLOUR/{TileMatrixSet}/{TileMatrix}/{TileCol}/{TileRow}.jpeg&KEY=3b3f5c60eca1404ea114e6941c9d3845',
                url: '/api/ogcservice/CheshireOS/?wmts/OS_AllBasemaps_COLOUR/{TileMatrixSet}/{TileMatrix}/{TileCol}/{TileRow}.jpeg&KEY=3b3f5c60eca1404ea114e6941c9d3845',
                layer: 'OS_AllBasemaps_COLOUR',
                matrixSet: 'osc_grid',
                format: 'image/jpeg',
                projection: 'EPSG:27700',
                requestEncoding: 'REST',
                tileGrid: new WMTSTileGrid({                    
                    //extent: [-3276800, -3276800, 3276800, 3276800],
                    origin: [-3276800.0, 3276800.0],
                    resolutions: [1792.003584007169, 896.0017920035843, 448.0008960017922, 224.0004480008961, 112.000224000448, 56.000112000224014, 28.000056000111993, 14.000028000056004, 7.000014000028002, 2.8000056000112004, 1.4000028000056002, 0.7000014000028001, 0.35000070000140004, 0.14000028000056003],
                    matrixIds: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13']
                }),             
                style: 'default',
                wrapX: false,
                attributions: `© Crown copyright and database rights 2021. Ordnance Survey 100049046. <a target='_blank' href='https://maps.cheshirewestandchester.gov.uk/cwac/psma/CWaCOSCopyright.htm'>Terms & Conditions.</a>`
            })
        });
        
        return new BaseLayer("CheshireCustom", "Ordnance Survey", lyr);
    }
}